import { render, staticRenderFns } from "./WaitAnimation.vue?vue&type=template&id=88f6566c&scoped=true&"
import script from "./WaitAnimation.vue?vue&type=script&lang=js&"
export * from "./WaitAnimation.vue?vue&type=script&lang=js&"
import style0 from "./WaitAnimation.vue?vue&type=style&index=0&id=88f6566c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f6566c",
  null
  
)

export default component.exports